import * as historyLib from '../node_modules/history';
import './helpers/passwordRecoveryToken';

export const createBrowserHistory = historyLib.createBrowserHistory;
export const createHashHistory = historyLib.createHashHistory;
export const createMemoryHistory = historyLib.createMemoryHistory;
export const createLocation = historyLib.createLocation;
export const createPath = historyLib.createPath;
export const locationsAreEqual = historyLib.locationsAreEqual;
export const parsePath = historyLib.parsePath;

const history = createBrowserHistory();

export default history;
